import React from "react";
import { Intent, Icon } from "@blueprintjs/core";
const {

    Filters: { AutoCompleteFilter, MultiSelectFilter, SingleSelectFilter },

} = require("react-data-grid-addons");




const confirm_formatter = ({ value }) => {
    let isConfirmed = value === "Yes" ? true : false;
    let iconname = isConfirmed ? "confirm" : "cross";
    let color = isConfirmed ? Intent.SUCCESS : Intent.DANGER;
    return <Icon icon = { iconname }
    intent = { color }
    />;
};

const boolean_formatter = ({ value }) => {
    let isTrue = value === "Yes" ? true : false;
    let iconname = isTrue ? "tick" : "cross";
    let color = isTrue ? Intent.SUCCESS : Intent.DANGER;
    return <Icon icon = { iconname }
    intent = { color }
    />;
};

let cols = [{
        key: "fullname",
        name: "Full Name",
        width: 150,
        filterRenderer: AutoCompleteFilter,
        resizable: true,
        sortable: true,
        filterable: true,
        frozen: true,
        visible: true,
    },
    {
        key: "confirmed",
        name: "Confirmed",
        width: 100,
        filterRenderer: SingleSelectFilter,
        formatter: confirm_formatter,
        resizable: true,
        sortable: true,
        filterable: true,
        frozen: true,
        visible: true,
    },
    {
        key: "phone",
        name: "Phone Number",
        width: 150,
        filterRenderer: AutoCompleteFilter,
        resizable: true,
        sortable: true,
        filterable: true,
        visible: true,
        draggable: true,
    },
    {
        key: "email",
        name: "Email",
        width: 150,
        filterRenderer: AutoCompleteFilter,
        resizable: true,
        sortable: true,
        filterable: true,
        visible: true,
        draggable: true,
    },
    {
        key: "attended",
        name: "Attended",
        width: 100,
        filterRenderer: SingleSelectFilter,
        formatter: boolean_formatter,
        resizable: true,
        sortable: true,
        filterable: true,
        visible: true,
        draggable: true,
    },
    {
        key: "canceled",
        name: "Canceled",
        width: 100,
        filterRenderer: SingleSelectFilter,
        formatter: boolean_formatter,
        resizable: true,
        sortable: true,
        filterable: true,
        visible: true,
        draggable: true,
    },
    /* {
       key: "waitlist",
       name: "Waitlist",
       width: 100,
       filterRenderer: SingleSelectFilter,
       formatter: boolean_formatter,
       resizable: true,
       sortable: true,
       filterable: true,
       visible: true,
       draggable: true,
     },*/
    {
        key: "rejected",
        name: "Rejected",
        width: 100,
        filterRenderer: SingleSelectFilter,
        formatter: boolean_formatter,
        resizable: true,
        sortable: true,
        filterable: true,
        visible: true,
        draggable: true,
    },
    {
        key: "walkin",
        name: "Walk-in",
        width: 100,
        filterRenderer: SingleSelectFilter,
        formatter: boolean_formatter,
        resizable: true,
        sortable: true,
        filterable: true,
        visible: true,
        draggable: true,
    },
    {
        key: "registration_date",
        name: "Registration Date",
        width: 150,
        filterRenderer: AutoCompleteFilter,
        resizable: true,
        sortable: true,
        filterable: true,
        visible: true,
        draggable: true,
    },
    {
        key: "beneficiary_type",
        name: "Beneficiary Type",
        width: 150,
        filterRenderer: MultiSelectFilter,
        resizable: true,
        sortable: true,
        filterable: true,
        visible: true,
        draggable: true,
    },
    {
        key: "business_sector",
        name: "Business Sector",
        width: 150,
        filterRenderer: MultiSelectFilter,
        resizable: true,
        sortable: true,
        filterable: true,
        visible: false,
        draggable: true,
    },
    {
        key: "region",
        name: "Region",
        width: 100,
        filterRenderer: MultiSelectFilter,
        resizable: true,
        sortable: true,
        filterable: true,
        draggable: true,
    },
    { key: "id", name: "id", visible: false, draggable: true },
];


export default cols;